import { Css, ModalBody, ModalHeader, useModal } from "@homebound/beam";
import { useHistory, useLocation } from "react-router";
import { Icon } from "src/components";
import { ReadyPlanOptionGroupPersonalizationType } from "src/generated/graphqlTypes";
import {
  AddToOptionModal_ReadyPlanOptionGroupFragment,
  useAddToOptionModal_PotentialOptionsQuery,
} from "src/routes/libraries/design-catalog/design-package-configurator/components/AddToOptionModal.generated";
import { createEditPersonalizationOptionUrl } from "src/RouteUrls";
import { foldEnum, pushInNextLoop, queryResult } from "src/utils";

type AddToOptionModalProps = { placeholderTliId: string; designPackageId: string; designPackageVersionId: string };

/** Given a regular placeholder TLI, show a list of existing personalization options that it can be added to. */
export function AddToOptionModal(props: AddToOptionModalProps) {
  const { placeholderTliId, designPackageId, designPackageVersionId } = props;
  const { closeModal } = useModal();
  const history = useHistory();
  const location = useLocation();
  const returnTo = `${location.pathname}${location.search}`;
  // query for existing DP option groups that match our placeholder TLI and it's "requirements".
  const query = useAddToOptionModal_PotentialOptionsQuery({
    variables: { designPackageId, designPackageVersionId, placeholderTliId },
  });

  function handleAddToOption(optionGroup: AddToOptionModal_ReadyPlanOptionGroupFragment) {
    closeModal();
    // push to the edit page for the option group, so the user can make a selection for the new variant slot
    pushInNextLoop(
      history,
      createEditPersonalizationOptionUrl(
        designPackageId,
        designPackageVersionId,
        optionGroup.id,
        placeholderTliId,
        returnTo,
      ),
    );
  }

  return (
    <>
      <ModalHeader>Add To Option</ModalHeader>
      <ModalBody>
        {queryResult(query, ({ designPackage }) => {
          const personalizationOptions = designPackage.potentialPersonalizationOptions || [];
          return personalizationOptions.isEmpty ? (
            <div>No Options Available</div>
          ) : (
            <ul css={Css.listReset.$}>
              {personalizationOptions.map((option) => (
                <li
                  key={option.id}
                  onClick={() => handleAddToOption(option)}
                  css={Css.cursorPointer.df.jcsb.lhPx(50).p1.onHover.bgBlue100.$}
                >
                  <div css={Css.lg.$}>{option.name}</div>
                  <Icon
                    icon={
                      // personalizationType should always be defined for personalization options
                      foldEnum(option.personalizationType!.code, {
                        [ReadyPlanOptionGroupPersonalizationType.Package]: "cube",
                        [ReadyPlanOptionGroupPersonalizationType.SingleProduct]: "link",
                        [ReadyPlanOptionGroupPersonalizationType.LinkedProduct]: "link",
                      })
                    }
                  />
                </li>
              ))}
            </ul>
          );
        })}
      </ModalBody>
    </>
  );
}
